import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root',
})
export class AuditService {
    private _apiUrl = environment.apiUrl;
    private _httpClient = inject(HttpClient);

    getAllAudits() {
        return this._httpClient.get(`${this._apiUrl}/v1/audit-logger/get-all-audit-logs`);
    }
}
